<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 4l5-2 6 2 5-2v14l-5 2-6-2-5 2V4z M7 2v14M13 4v14"
      stroke="currentColor"
      stroke-width="1.3"
      fill="none"
      stroke-linejoin="round"
    />
  </svg>
</template>
